const getQuantity = (item: any) => {
  return item?.new_quantity ?? item?.quantity ?? 0;
}
export default getQuantity;